import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMessageTickDouble = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M1 6.25L3.25 8.5L6.75 4.75",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M4.5 6.75L6.25 8.5L10.5 3.75",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgMessageTickDouble;
